// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1K9pD","inputWrap":"Table_inputWrap__MB_Wm","col":"Table_col__LTS97","bmiTooltip":"Table_bmiTooltip__sfUd-"};